
import Button from '../../../components/base/Button';

export default function HeroSection() {
  return (
    <section 
      className="relative bg-dark-950 text-white min-h-screen flex items-center bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(rgba(15, 23, 42, 0.8), rgba(185, 28, 28, 0.4)), url('https://static.readdy.ai/image/9d1a81acaff8e51df20fb8b8c1aae197/a0624eed956b16f321aa9bd5f1cc0e5b.jfif')`
      }}
    >
      <div className="container mx-auto px-4 sm:px-6 py-12 sm:py-20" style={{ paddingTop: '10vh' }}>
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-16 items-center max-w-7xl mx-auto">
          {/* Content - Left side on desktop, repositioned for mobile */}
          <div className="space-y-6 sm:space-y-8 order-2 lg:order-1 mt-40 sm:mt-0">
            {/* Title and Description */}
            <div className="space-y-4 sm:space-y-6 text-center sm:text-left">
              <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-red-400 leading-tight">
                Hi, I'm <span className="text-white">Tony Monteiro</span><br />
                Your Mortgage Expert
              </h1>
              <p className="hidden sm:block text-base sm:text-lg lg:text-xl text-gray-300 leading-relaxed max-w-2xl mx-auto sm:mx-0">
                Level 2 Certified Mortgage Professional with a quarter-century of experience 
                helping Ontario families achieve their homeownership dreams.
              </p>
            </div>
            
            {/* CTA Buttons - Hidden on mobile */}
            <div className="hidden sm:flex flex-col sm:flex-row gap-3 sm:gap-4">
              <a 
                href="https://calendly.com/tmonteiro-mortgagealliance/30min"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button variant="primary" size="lg" className="w-full sm:w-auto px-4 sm:px-8 py-3 sm:py-4 text-base sm:text-lg">
                  <i className="ri-calendar-line mr-2"></i>
                  <span className="sm:hidden">Book Call</span>
                  <span className="hidden sm:inline">Book a Call</span>
                </Button>
              </a>
              <a href="tel:5196583026">
                <Button variant="outline" size="lg" className="w-full sm:w-auto px-4 sm:px-8 py-3 sm:py-4 text-base sm:text-lg bg-red-600 text-white hover:bg-red-700 border-red-600">
                  <i className="ri-phone-line mr-2"></i>
                  (519) 658-3026
                </Button>
              </a>
            </div>
            {/* Trust indicators - Cleaner mobile layout */}
            <div className="pt-4 sm:pt-8">
              <div className="grid grid-cols-3 gap-4 max-w-sm mx-auto sm:max-w-none sm:flex sm:gap-6 sm:mx-0">
                <div className="text-center sm:text-left">
                  <div className="text-xl sm:text-2xl lg:text-3xl font-bold text-red-400 mb-1">25+</div>
                  <div className="text-xs sm:text-sm text-gray-400 leading-tight">Years<br className="sm:hidden" /> Experience</div>
                </div>
                <div className="text-center sm:text-left">
                  <div className="text-xl sm:text-2xl lg:text-3xl font-bold text-red-400 mb-1">Level 2</div>
                  <div className="text-xs sm:text-sm text-gray-400 leading-tight">Certified</div>
                </div>
                <div className="text-center sm:text-left">
                  <div className="text-xl sm:text-2xl lg:text-3xl font-bold text-red-400 mb-1">Ontario</div>
                  <div className="text-xs sm:text-sm text-gray-400 leading-tight">Licensed</div>
                </div>
              </div>
            </div>

            {/* Mobile Contact Info - Cleaner presentation */}
            <div className="sm:hidden bg-dark-800/80 backdrop-blur-sm rounded-2xl p-4 mt-6 border border-red-600/20">
              <div className="text-center space-y-3">
                <div className="text-sm text-gray-300">Ready to get started?</div>
                <a 
                  href="tel:5196583026" 
                  className="flex items-center justify-center gap-2 text-red-400 hover:text-red-3

                  .3 font-semibold text-lg"
                >
                  <i className="ri-phone-line"></i>
                  (519) 658-3026
                </a>
                <div className="text-xs text-gray-400">Tap to call • Available 7 days a week</div>
              </div>
            </div>
          </div>

          {/* Brokerage Section - Right side on desktop */}
          <div className="hidden lg:flex justify-center lg:justify-end order-1 lg:order-2">
            <div className="relative max-w-sm xl:max-w-md text-center">
              {/* Brokerage Logo */}
              <div className="bg-dark-800 rounded-3xl p-8 shadow-2xl border-4 border-red-600/30 mb-6">
                <img 
                  src="https://static.readdy.ai/image/9d1a81acaff8e51df20fb8b8c1aae197/bcdcde40e3d45c7721e4a634ef58f84e.png"
                  alt="Greater Golden Horseshoe Mortgages"
                  className="w-full h-auto max

                  -max-w-xs mx-auto"
                />
              </div>
              
              {/* Brokerage Information */}
              <div className="bg-dark-900/90 backdrop-blur-sm

                rounded-2xl p-6 border border-red-600/30">
                <h3 className="text-2xl font-bold text-white mb-3">
                  Greater Golden Horseshoe
                  <br />
                  <span className="text-red-400">Mortgages</span>
                </h3>
                <div className="space-y-2

                  text-gray-300">
                  <div className="flex items-center justify-center

                    gap-2">
                    <i className="ri-shield-check-line text-red-400"></i>
                    <span className="font-semibold">Licensed Brokerage</span>
                  </div>
                  <div className="text-lg font-bold text-red-400">Lic# 131

                    21</div>
                  <div className="text-sm">Independently Owned & Operated</div>
                </div>
              </div>

              {/* Professional badges */}
              <div className="absolute -bottom-3 -right-3 bg-red-600 text-white px-3 py-1 rounded

                -full text-sm font-bold shadow-lg">
                25+ Years
              </div>
              <div className="absolute -top-3 -left-3 bg-dark-800 text-white

                px-3 py-1 rounded-full text-sm font-bold shadow-lg">
                Level 2
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
